import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/guarantees';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillReady(resolve) {
        this.widgetsHelper.getWidgets.call(this);
        resolve();
    }
    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }
}
